import CustomDatatableWithSearch from 'libs/datatables/custom_datatable_with_search'
export default function () {
  $(function() {
    const options = {disableCompactMode: true}
    new CustomDatatableWithSearch($('#expenses-index-table'), $('#search'), options)
  })
}
